import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatAhv'
})
export class FormatAhvPipe implements PipeTransform {
  transform(ahvNr: string): string {
    if (!ahvNr) {
      return '';
    }
    if (ahvNr.length === 11) {
      return this.formatAhv11(ahvNr);
    }
    if (ahvNr.length === 13) {
      return this.formatAhv13(ahvNr);
    }
    return '';
  }

  formatAhv13(ahvNr: string): string {
    const prefix = ahvNr.substring(0, 3);
    const part1 = ahvNr.substring(3, 7);
    const part2 = ahvNr.substring(7, 11);
    const part3 = ahvNr.substring(11, 13);
    return prefix + '.' + part1 + '.' + part2 + '.' + part3;
  }

  formatAhv11(ahvNr: string): string {
    const prefix = ahvNr.substring(0, 3);
    const part1 = ahvNr.substring(3, 5);
    const part2 = ahvNr.substring(5, 8);
    const part3 = ahvNr.substring(8, 11);
    return prefix + '.' + part1 + '.' + part2 + '.' + part3;
  }
}
